import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from 'react-apollo';
import ReactImageFallback from 'react-image-fallback';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import {
  UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import { map, find } from 'lodash';
import moment from 'moment';
import {
  INSTA_BLACK_ICON, FALLBACK_ICON, OFFER_TYPE, dateFormats, isSameDay, routeConstants, FACEBOOK_BLACK_ICON, SPOTIFY_BLACK_ICON, getDaysDiff,
  TWITTER_BLACK_ICON, YOUTUBE_BLACK_ICON, handleGraphqlError, BETA_POST_ENUM, staticConstants, ICON_TYPE, NUMERIC_VALUE, BETA_POST_TITLE, renderDateRange, Messages,
} from '../../../../utils';
import {
  BetaPostRequest, BetaPostApproved, InviteArtistModal, SeeContract, DeleteOffer,
} from '../../../modals';
import { INVITE_ARTIST, LOADER_MUTATION } from '../../../../graphql-client/mutations';
import { useChatMessageInitializer } from '../../../../utils/chatMessageInitializer';

function OfferDetail(props) {
  useChatMessageInitializer();
  const { addToast } = useToasts();
  const scrollRef = useRef([]);
  const location = useLocation();
  const {
    offerData, onDeleteOfferCallback, updateOfferListing, scrollToSegmentId,
  } = props;
  const [betaPostRequestModal, setBetaPostRequestModal] = useState(false);
  const [betaPostApprovedModal, setBetaPostApprovedModal] = useState(false);
  const [inviteArtistModal, setInviteArtistModal] = useState(false);
  const [isSeeContractModal, setSeeContractModal] = useState(false);
  const [isDeleteOfferModal, setDeleteOfferModal] = useState(false);
  const [apiData, setApiData] = useState();
  const [displayUser, setDisplayUser] = useState();
  const [segment, setSegmentId] = useState();
  const [betaPostId, setBetaPostId] = useState();
  const [selectedSegmentItem, setSelectedSegmentItem] = useState();
  const offerId = offerData && offerData._id;
  const checkExpiredOffer = offerData && moment(offerData.offerMaxDate).diff(moment(), 'minutes');
  const offerStartInterval = offerData.offerMinDate && moment(offerData.offerMinDate).diff(moment(), 'minutes');

  const goToBackPath = () => {
    if (location.state && location.state.isFrom) {
      const routeListingPage = location.state.isFrom === staticConstants.COMPONENT_KEYWORDS.ADMIN_ARTIST_PAGE
        ? `${routeConstants.ADMIN_ARTIST}` : `${routeConstants.ADMIN_MANAGER}`;
      return location.state.isFrom === staticConstants.COMPONENT_KEYWORDS.ADMIN_ANALYTICS_PAGE
        ? `${routeConstants.ADMIN_ANALYTICS}` : routeListingPage;
    }
    return `${routeConstants.ADMIN_OFFER}`;
  };

  const toggleInviteArtistModal = () => {
    setInviteArtistModal(!inviteArtistModal);
  };

  const toggleSeeContractModal = () => {
    setSeeContractModal(!isSeeContractModal);
  };

  const toggleBetaPostRequestModal = (user, item) => {
    setDisplayUser(user);
    setSegmentId(item && item.segmentId);
    setBetaPostId(item && item.betaPostId);
    setBetaPostRequestModal(!betaPostRequestModal);
  };
  const toggleBetaPostApprovedModal = (user) => {
    setDisplayUser(user);
    setBetaPostApprovedModal(!betaPostApprovedModal);
  };

  const toggleDeleteOfferModal = () => {
    setDeleteOfferModal(!isDeleteOfferModal);
  };

  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: {},
  });

  const [inviteArtist] = useMutation(INVITE_ARTIST, {
    variables: apiData,
    onError(err) {
      loaderMutate({ show: false });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(inviteData) {
      loaderMutate({ show: false });
      addToast(inviteData.inviteArtists.message, { appearance: 'success' });
    },

  });

  useEffect(() => {
    apiData && inviteArtist();
  }, [apiData]);

  useEffect(() => {
    scrollRef.current = [];
  }, []);

  useEffect(() => {
    setTimeout(() => {
      scrollToSegmentId && scrollRef.current[scrollToSegmentId] && scrollRef.current[scrollToSegmentId].scrollIntoView();
    }, 100);
  }, [scrollToSegmentId]);

  const onInviteArtist = (queryObj) => {
    queryObj.offerId = offerId;
    loaderMutate({ show: true });
    setApiData(queryObj);
  };

  const requestStatusClass = (ele) => {
    let classValue = '';
    if (ele === BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN) {
      classValue = staticConstants.STATUS_TYPE_CLASSNAME.REQUESTED;
    } else if (ele === BETA_POST_ENUM.BETA_POST_APPROVED) {
      classValue = staticConstants.STATUS_TYPE_CLASSNAME.ACCEPT;
    } else if (ele === BETA_POST_ENUM.REJECTED) {
      classValue = staticConstants.STATUS_TYPE_CLASSNAME.REJECT;
    } else if (ele === BETA_POST_ENUM.PUBLISHED || ele === BETA_POST_ENUM.COMPLETED) {
      classValue = staticConstants.STATUS_TYPE_CLASSNAME.COMPLETED;
    }
    return classValue;
  };

  const requestFunctionToCall = (user, item) => {
    setSelectedSegmentItem(item);
    if (user.status === BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN) {
      return toggleBetaPostRequestModal(user, item);
    }
    if (user.status === BETA_POST_ENUM.BETA_POST_APPROVED || user.status === BETA_POST_ENUM.REJECTED
      || user.status === BETA_POST_ENUM.PUBLISHED || user.status === BETA_POST_ENUM.COMPLETED) {
      return toggleBetaPostApprovedModal(user);
    }
    return null;
  };

  const getBetaPostAvailTitle = (participantsList) => {
    const getStatusArray = find(participantsList, ({ status }) => [BETA_POST_ENUM.BETA_POST_APPROVED,
      BETA_POST_ENUM.REJECTED, BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN, BETA_POST_ENUM.COMPLETED, BETA_POST_ENUM.PUBLISHED].indexOf(status) > -1);
    return getStatusArray ? BETA_POST_TITLE.BETA_POST_REQUEST : BETA_POST_TITLE.NO_BETA_POST_REQUEST;
  };

  const requestDetails = (item) => item && item.participants.map((ele) => (
    [BETA_POST_ENUM.BETA_POST_REQUESTED_ADMIN,
      BETA_POST_ENUM.REJECTED, BETA_POST_ENUM.BETA_POST_APPROVED, BETA_POST_ENUM.COMPLETED, BETA_POST_ENUM.PUBLISHED].indexOf(ele.status) > -1
    && (
      <div className="artist-profile" key={Math.random()}>
        <span
          className="cursor-pointer"
          onClick={() => requestFunctionToCall(ele, item)}
        >
          <img
            src={ele.user && ele.user.artistImage}
            alt="user"
            className="image-cover"
          />
        </span>
        <em className={requestStatusClass(ele.status)} />
      </div>
    )
  ));

  const renderSegmentView = () => {
    const timelineList = offerData && offerData.campaignTimeline;
    const requestData = offerData && offerData.segmentParticipants;
    const createMarkup = (description) => {
      const alteredContent = { __html: description };
      if (alteredContent.__html.toLowerCase().includes('<img')) {
        const alteredContent2 = { __html: description }.__html.toLowerCase().split('alt')[0].concat('alt="" width="455" height="350"/></p>');
        return { __html: alteredContent2 };
      }
      return { __html: description };
    };
    return map(((requestData.length && requestData) || timelineList), (item) => item && (
      <div
        ref={(el) => { scrollRef.current[item._id || item.segmentId] = el; }}
        className={`offer-detail-wrapper-card ${getDaysDiff(offerData && offerData.offerMaxDate, new Date()) > NUMERIC_VALUE.ZERO ? 'pointer-none' : ''}`}
        key={Math.random()}
      >
        <h2>
          {moment(item.startDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}
          {
            item.startDate && !isSameDay(item.startDate, item.endDate) && ` - ${moment(item.endDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}`
          }
          <div className="inline-social-icons">
            {
              (item.shareType && item.shareType.instagram)
              && (
                <span>
                  <img src={INSTA_BLACK_ICON} alt="Instagram" />
                </span>
              )
            }
            {
              (item.shareType && item.shareType.facebook)
              && (
                <span>
                  <img src={FACEBOOK_BLACK_ICON} alt="facebook" />
                </span>
              )
            }
            {
              (item.shareType && item.shareType.twitter)
              && (
                <span>
                  <img src={TWITTER_BLACK_ICON} alt="twitter" />
                </span>
              )
            }
            {
              (item.shareType && item.shareType.youtube)
              && (
                <span>
                  <img src={YOUTUBE_BLACK_ICON} alt="youtube" />
                </span>
              )
            }

            {
              (item.shareType && item.shareType.spotify)
              && (
                <span>
                  <img src={SPOTIFY_BLACK_ICON} alt="spotify" />
                </span>
              )
            }
          </div>
        </h2>
        <div dangerouslySetInnerHTML={createMarkup(item.description)} />
        <div className="hashtag-wrapper">
          <h4>HashTags to be added </h4>
          <p>{`${item.hashTag}`}</p>
        </div>
        {requestData.length > 0 && (
          <div className="shared-artist">
            <h4>{getBetaPostAvailTitle(item.participants)}</h4>
            {requestDetails(item)}
          </div>
        )}
      </div>
    ));
  };

  const renderCategoryIcons = () => {
    const categories = offerData && offerData.categories;
    return map(categories, (item) => item && (
      <img
        key={`categories-${item.label}`}
        src={ICON_TYPE[item.label]}
        alt={item.label}
      />
    ));
  };

  const copyToClipAction = () => {
    addToast(Messages.copyLinkSuccess, { appearance: 'success' });
  };
  const baseUrl = window.location.host;

  return (
    <div className="offer-detail-wrapper">
      <div className="offer-detail-wrapper-content">
        <div className="offer-detail-wrapper-head-before">
          <Link to={goToBackPath}>
            <span className="icon icon-next rotate-180" />
            Back
          </Link>
          <div className="filter-icons">
            {renderCategoryIcons()}
          </div>
        </div>
        <div className="offer-detail-wrapper-head">
          {
            !offerData?.isClientLogoHide
            && (
              <div className="offer-detail-wrapper-head-image">
                <ReactImageFallback
                  src={offerData.clientLogo}
                  fallbackImage={FALLBACK_ICON}
                  alt="Offer"
                />
              </div>
            )
          }
          <div className={`offer-detail-wrapper-head-detail ${offerData?.isClientLogoHide ? 'p-0' : ''}`}>
            <p>{offerData && offerData.clientName}</p>
            <h2>
              {offerData && offerData.title}
            </h2>
            <span>{offerData && OFFER_TYPE[offerData.campaignType]}</span>
            <span className="ml-1">{offerData && OFFER_TYPE[offerData.viewType]}</span>
            {
              offerData.viewType === staticConstants.STATUS_TYPE.PUBLIC
              && <span className="ml-1">{OFFER_TYPE[offerData.gigType]}</span>
            }
            <em>
              {renderDateRange(offerData.offerMinDate, offerData.offerMaxDate)}
            </em>
            <div className="copy-url-container">
              <CopyToClipboard text={`${baseUrl}${routeConstants.DASHBOARD}?offerId=${offerId}`} onCopy={copyToClipAction}>
                <span className="copy-url-btn" />
              </CopyToClipboard>
              <span className="copy-url-text">Copy URL</span>
            </div>
            <UncontrolledButtonDropdown className="action-dropdown-toggle">
              <DropdownToggle>
                <div className="modal-toggle" />
              </DropdownToggle>
              <DropdownMenu right className="dropdown-theme card-dropdown">
                {
                  (checkExpiredOffer > 0 && offerStartInterval > 0)
                  && (
                    <DropdownItem
                      onClick={() => { offerData && toggleInviteArtistModal(); }}
                    >
                      Invite Artists
                    </DropdownItem>
                  )
                }
                <DropdownItem
                  onClick={() => { offerData && offerData.createContract && toggleSeeContractModal(); }}
                >
                  See contract
                </DropdownItem>
                <Link
                  to={{
                    pathname: `${routeConstants.EDIT_OFFER}/${offerId}`,
                    state: { isOfferListing: false, offerId },
                  }}
                >
                  <DropdownItem>
                    Edit
                  </DropdownItem>
                </Link>

                <DropdownItem
                  className="text-red"
                  onClick={() => { offerData && toggleDeleteOfferModal(); }}
                >
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        </div>
        <p className="short-description">
          {offerData && offerData.description}
        </p>
        {renderSegmentView()}
      </div>
      {inviteArtistModal && (
        <InviteArtistModal
          isOpen={inviteArtistModal}
          onClose={() => { toggleInviteArtistModal(); }}
          publishAndInviteOffer={onInviteArtist}
          categoriesData={offerData && offerData.categories}
          basePrice={offerData && offerData.basePrice}
          isInviteOnly
          offerId={offerId}
          targetAudience={offerData && offerData.targetAudience}
          isPrivateType={offerData && offerData.viewType === staticConstants.STATUS_TYPE.PRIVATE}
        />
      )}

      {isSeeContractModal && (
        <SeeContract
          isOpen={isSeeContractModal}
          onClose={() => { toggleSeeContractModal(); }}
          offerData={offerData}
        />
      )}

      {isDeleteOfferModal && (
        <DeleteOffer
          isOpen={isDeleteOfferModal}
          onClose={() => { toggleDeleteOfferModal(); }}
          offerId={offerId}
          deleteOffer={() => { onDeleteOfferCallback(offerId); }}
        />
      )}

      {betaPostRequestModal && (
        <BetaPostRequest
          offerId={offerId}
          displayUser={displayUser}
          segmentId={segment}
          isOpen={betaPostRequestModal}
          shareType={selectedSegmentItem.shareType}
          onClose={() => { toggleBetaPostRequestModal(); }}
          updateOfferDetail={updateOfferListing}
          betaPostId={betaPostId}
        />
      )}
      {betaPostApprovedModal && (
        <BetaPostApproved
          displayUser={displayUser}
          isOpen={betaPostApprovedModal}
          shareType={selectedSegmentItem.shareType}
          onClose={() => { toggleBetaPostApprovedModal(); }}
          sharedPost={selectedSegmentItem.sharedPost}
        />
      )}
    </div>
  );
}

OfferDetail.propTypes = {
  offerData: PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    clientName: PropTypes.string,
    campaignType: PropTypes.string,
    viewType: PropTypes.string,
    gigType: PropTypes.string,
    description: PropTypes.string,
    clientLogo: PropTypes.string,
    targetAudience: PropTypes.object,
    isClientLogoHide: PropTypes.bool,
    campaignTimeline: PropTypes.arrayOf(PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      description: PropTypes.string,
      segmentId: PropTypes.string,
      shareType: PropTypes.shape({
        facebook: PropTypes.bool,
        instagram: PropTypes.bool,
        twitter: PropTypes.bool,
        youtube: PropTypes.bool,
        spotify: PropTypes.bool,
      }),
      sharedPost: PropTypes.shape({
        facebookUrl: PropTypes.string,
        instagramUrl: PropTypes.string,
        twitterUrl: PropTypes.string,
        youtubeUrl: PropTypes.string,
        spotifyUrl: PropTypes.string,
      }),
    })),
    segmentParticipants: PropTypes.arrayOf(PropTypes.shape({
      segmentId: PropTypes.string,
    })),
    basePrice: PropTypes.number,
    createContract: PropTypes.string,
    createdAt: PropTypes.string,
    offerMinDate: PropTypes.string,
    offerMaxDate: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })),
  }),
  onDeleteOfferCallback: PropTypes.func.isRequired,
  updateOfferListing: PropTypes.func.isRequired,
  scrollToSegmentId: PropTypes.string,
};

OfferDetail.defaultProps = {
  offerData: null,
  scrollToSegmentId: null,
};

export default React.memo(OfferDetail);
